// @ts-nocheck
import _ from 'lodash';
import { captureClientSideError } from './errors';
import logger from '@scale/frontend-lib/logging';
import { Event, logEvent } from 'react-scale/lib/events';

const NONE = 'none'; // placeholder to essential unset a user var

export function setAssignmentUserVars({
  attemptId = null,
  subtaskId = null,
  productName = null,
  courseId = null,
}: {
  attemptId?: string | null;
  subtaskId?: string | null;
  productName?: string | null;
  courseId?: string | null;
}) {
  attemptId = attemptId || NONE;
  subtaskId = subtaskId || NONE;
  productName = productName || NONE;
  courseId = courseId || NONE;
  const userVars = {
    subtaskToAttempt_str: NONE,
    attemptToReview_str: NONE,
    subtaskToReview_str: NONE,
    product_name_str: NONE,
    course_id_str: NONE,
  };

  if (attemptId !== NONE) {
    userVars.subtaskToReview_str = subtaskId;
    userVars.attemptToReview_str = attemptId;
  } else {
    userVars.subtaskToAttempt = subtaskId;
  }

  // For Document AI Go sessions.
  if (productName !== NONE) {
    userVars.product_name_str = productName;
  }

  if (courseId !== NONE) {
    userVars.course_id_str = courseId;
  }

  setUserVars(userVars);
}

function setUserVars(...args) {
  if (window.FS && window.FS.setUserVars) {
    return window.FS.setUserVars(...args);
  }
}

export function getCurrentSessionURL(now: boolean, workerId?: string, taskId?: string) {
  if (window.FS && window.FS.getCurrentSessionURL) {
    const sessionURL = window.FS.getCurrentSessionURL(now);
    logEvent(Event.FullstorySessionEvent, {
      eventType: 'frontend',
      workerId,
      taskId,
      fullstorySession: sessionURL,
    });
    return sessionURL;
  } else {
    logger.info(`fullstory not initialized`);
    logEvent(Event.FullstorySessionEvent, {
      eventType: 'frontend',
      workerId,
      taskId,
    });
  }
}

/**
 * Run a function when fullstory is loaded.
 *
 * Some of the FS attributes are loaded separately from the segment snippet.
 * If you need these, set needLoadedAttrs to true.
 *
 * These attributes include:
 *  - FS.getCurrentSession
 *  - FS.getCurrentSessionURL
 *  - FS.identify
 *  - FS.identifyAccount
 *  - FS.log
 *  - FS.disableConsole
 *  - FS.enableConsole
 */
export function doOnFsReady(fn, needLoadedAttrs = false) {
  if (!_.get(window, needLoadedAttrs ? 'FS.setUserVars' : 'FS.log')) {
    window._fs_ready = fn;
  } else {
    try {
      fn();
    } catch (e) {
      captureClientSideError(e, 'fullstory', {}, 'warning');
    }
  }
}
